var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsInDelivery = function SvgNnIconFlagsInDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-IN-delivery_svg__Lager_61",
    "data-name": "Lager 61",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-IN-delivery_svg__cls-1{fill:#fff}.nn-icon-flags-IN-delivery_svg__cls-5{fill:#0030bf}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-IN-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v11.1H.25z",
    style: {
      fill: "#f70"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 22.46h49.97v11.1H.25z",
    style: {
      fill: "#178c00"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 12.47a4.44 4.44 0 1 1-4.44 4.44 4.44 4.44 0 0 1 4.44-4.44",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 13.02a3.89 3.89 0 1 1-3.89 3.89 3.89 3.89 0 0 1 3.89-3.89",
    className: "nn-icon-flags-IN-delivery_svg__cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.13a.78.78 0 1 1-.78.78.78.78 0 0 1 .78-.78",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.11 17.22a.21.21 0 0 1 .17.22.21.21 0 0 1-.22.17.19.19 0 0 1-.17-.22.2.2 0 0 1 .22-.17M25.23 20.8l.13-2.34-.13-1.11-.13 1.11Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.89 18.22a.193.193 0 1 1-.14.36.2.2 0 0 1-.11-.26.19.19 0 0 1 .25-.1M24.23 20.66l.74-2.21.16-1.11-.42 1Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-3",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.43 19.12a.19.19 0 0 1 0 .27.193.193 0 0 1-.31-.23.19.19 0 0 1 .31-.04M23.29 20.28l1.28-2 .44-1-.67.9Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-4",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.75 19.91a.2.2 0 1 1-.31.24.2.2 0 0 1 .31-.24M22.48 19.66l1.75-1.56.7-.88-.88.69Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-3",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-5",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9 20.43a.19.19 0 1 1-.26-.11.2.2 0 0 1 .26.11M21.86 18.85l2.09-1 .9-.67-1 .44Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-6",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.93 20.74a.21.21 0 0 1-.17.22.21.21 0 0 1-.22-.17.2.2 0 0 1 .17-.22.19.19 0 0 1 .22.17M21.48 17.91l2.28-.48 1-.42-1.11.16Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-4",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-7",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.92 20.79a.21.21 0 0 1-.22.17.21.21 0 0 1-.17-.22.19.19 0 0 1 .22-.17.2.2 0 0 1 .17.22M21.34 16.91l2.34.13 1.11-.13-1.11-.13Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-8",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.92 20.57a.193.193 0 1 1-.36-.14.2.2 0 0 1 .26-.11.19.19 0 0 1 .1.25M21.48 15.91l2.21.74 1.11.16-1-.42Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-5",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-9",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.02 20.11a.2.2 0 1 1 0-.27.19.19 0 0 1 0 .27M21.86 14.97l2 1.28 1 .44-.9-.67Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-10",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.23 19.43a.19.19 0 0 1-.27 0 .193.193 0 1 1 .31-.23.19.19 0 0 1-.04.23M22.48 14.16l1.56 1.75.88.7-.7-.88Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c-3",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-6",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-11",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.71 18.58a.2.2 0 0 1-.25-.11.2.2 0 0 1 .36-.15.2.2 0 0 1-.11.26M23.29 13.54l1 2.09.67.9-.44-1Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-12",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4 17.61a.21.21 0 0 1-.22-.17.21.21 0 0 1 .17-.22.2.2 0 0 1 .22.17.19.19 0 0 1-.17.22M24.23 13.16l.48 2.28.42 1-.16-1.11Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__d-2",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-7",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-13",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.35 16.6a.21.21 0 0 1-.17-.22.21.21 0 0 1 .22-.17.19.19 0 0 1 .17.22.2.2 0 0 1-.22.17M25.23 13.02l-.13 2.34.13 1.11.13-1.11Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-14",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.57 15.6a.19.19 0 0 1-.11-.25.2.2 0 0 1 .25-.11.2.2 0 0 1 .11.26.19.19 0 0 1-.25.1M26.23 13.16l-.74 2.21-.16 1.11.42-1Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c-4",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-8",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-15",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.03 14.7a.19.19 0 0 1 0-.27.193.193 0 1 1 .31.23.19.19 0 0 1-.31.04M27.17 13.54l-1.28 2-.44 1 .67-.9Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-16",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.71 13.91a.19.19 0 0 1 0-.27.193.193 0 0 1 .23.31.19.19 0 0 1-.23-.04M27.98 14.16l-1.75 1.56-.69.88.88-.7Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-9",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-17",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.56 13.39a.19.19 0 1 1 .26.11.2.2 0 0 1-.26-.11M28.6 14.97l-2.09 1-.9.67 1-.44Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-18",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.53 13.08a.21.21 0 0 1 .17-.22.21.21 0 0 1 .22.17.2.2 0 0 1-.17.22.19.19 0 0 1-.22-.17M28.98 15.91l-2.28.48-1 .42 1.11-.16Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c-5",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-10",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-19",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.54 13.03a.21.21 0 0 1 .22-.17.21.21 0 0 1 .17.22.19.19 0 0 1-.22.17.2.2 0 0 1-.17-.22M29.12 16.91l-2.34-.13-1.11.13 1.11.13Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-20",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.54 13.25a.193.193 0 0 1 .36.14.2.2 0 0 1-.26.11.19.19 0 0 1-.1-.25M28.98 17.91l-2.21-.74-1.11-.16 1 .42Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__d-3",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-11",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-21",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.44 13.71a.19.19 0 0 1 .27 0 .193.193 0 1 1-.23.31.19.19 0 0 1-.04-.31M28.6 18.85l-2-1.28-1-.44.9.67Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-22",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.23 14.39a.19.19 0 0 1 .27 0 .193.193 0 0 1-.31.23.19.19 0 0 1 .04-.23M27.98 19.66l-1.56-1.75-.88-.69.69.88Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__c-6",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__b-12",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-23",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 15.24a.19.19 0 1 1-.11.26.2.2 0 0 1 .11-.26M27.17 20.28l-1-2.09-.67-.9.44 1Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-IN-delivery_svg__a-24",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.06 16.21a.21.21 0 0 1 .22.17.21.21 0 0 1-.17.22.2.2 0 0 1-.22-.17.19.19 0 0 1 .17-.22M26.23 20.66l-.48-2.28-.42-1 .16 1.11Z",
    className: "nn-icon-flags-IN-delivery_svg__cls-5"
  })))))));
};
export default SvgNnIconFlagsInDelivery;